export default __webpack_public_path__ + "static/media/review.e17f9c0e.png";